// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"ba2e3b1d","97":"fb227bb6","207":"48b92014","453":"d1cd3c24","543":"a3f0091d","572":"e9759363","682":"2bed934e","699":"47eaf9f9","818":"ea831a3a","820":"78899d63","873":"e855b94e"}[chunkId] + ".chunk.js";
};